import { PropsWithChildren } from 'react'
import styles from './ArticleBody.module.scss'

const ArticleBody = ({ children }: PropsWithChildren) => {
  return <section className={styles['article-body']}>{children}</section>
}

export default ArticleBody
